export const SurveyAnswerStatus = {
  never_answered: 'never_answered',
  no_answer: 'no_answer',
  partial_answerd: 'partial_answerd',
  answer_complete: 'answer_complete',
  offer_accepted: 'offer_accepted',
  offer_consumed: 'offer_consumed'
}

export const PSS_LOCAL_STORAGE_KEY = {
  SURVEY_MODAL_CLOSED_AT: 'surveyModalClosedAt',
  SURVEY_BANNER_CLOSED_AT: 'surveyBannerClosedAt',
  SURVEY_BANNER_ID: 'surveyBannerId',
  SURVEY_BANNER_ANSWER_STATUS: 'surveyBannerAnswerStatus'
}
